import type { LearnerExam } from "../content-schema";

/** One deterministic route shared by the runner, response validation and results. */
export function fixedModules(exam: LearnerExam) {
  return (["reading_writing", "math"] as const).flatMap((section) => [1, 2].flatMap((stage) => {
    const modules = exam.modules.filter((module) => !module.variantOf && module.section === section && module.stage === stage);
    return modules.find((module) => module.routeBand === "common" || module.routeBand === "unknown") ?? modules[0] ?? [];
  }));
}
export function fixedItems(exam: LearnerExam) {
  return fixedModules(exam).flatMap((module) => module.items.flatMap((item) => item.questionId ? [{ ...item, questionId: item.questionId, moduleId: module.id }] : []));
}
